import { render, staticRenderFns } from "./UserClocking.vue?vue&type=template&id=508214aa&scoped=true&"
import script from "./UserClocking.vue?vue&type=script&lang=js&"
export * from "./UserClocking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508214aa",
  null
  
)

export default component.exports